import { stringify } from 'csv/lib/sync';

export function toCsv(columns, orginalData) {

	var output = '';
	
	var data = [];

	for (var rowIndex = 0; rowIndex < orginalData.length; rowIndex++) {
		data[rowIndex] = [];
	}

	for (var columnIndex = 0; columnIndex < columns.length; columnIndex++) {
		const column = columns[columnIndex];

		output += column.title;
		
		if (columnIndex < (columns.length-1)) {
			output += ',';
		}

		for (rowIndex = 0; rowIndex < orginalData.length; rowIndex++) {
			var cell = orginalData[rowIndex][column.property];

			if (undefined !== cell && null != cell) {

				if (undefined !== column.formatter) {

					if ((undefined !== cell.numerator) && (undefined !== cell.denominator)) {
						cell = column.formatter(cell).replace(' / ', ' | ');
					}
					else {
						cell = column.formatter(cell);
					}
				}
	
				if ('=' ===  cell[0] || '+' ===  cell[0] || '-' ===  cell[0] || '@' ===  cell[0]) {
					cell = "'" + cell;
				}
				data[rowIndex][columnIndex] = cell;
			}
		}
	
	}

	output += '\n';

	// const formatObject = function(columns, value, context) {
	// 	const column = columns[context.index];
	// 	if (undefined !== column.formatter) {
			
	// 	}
	// 	return value;
	// };

	output += stringify(data,
		{
			header:false,
			cast: {
				// object: (value, context) => formatObject(columns, value, context)
			}
		});
	
	// console.log(`toCsv`, columns, orginalData, data, output);

	return output;
}

export function mapToCsv(orginalData) {

	var output = stringify(orginalData,
		{
			header:false,
			cast: {
				// object: (value, context) => formatObject(columns, value, context)
			}
		});

		return output;
}

export function downloadAsCSV(document, fileName, columns, data){
	
	console.log(`downloadAsCSV fileName=${fileName}`, columns, data);

	try{
		const element = document.createElement("a");
	
		var csvText = '';
		
		if(columns !== undefined && data !== undefined){
			csvText = toCsv(columns, data);
		}
		else if(columns === undefined && data !== undefined){
			csvText = mapToCsv(data);
		}
	
		const file = new Blob([csvText], {type: 'text/plain;charset=utf-8'});
		element.href = URL.createObjectURL(file);
		element.download = fileName;
		document.body.appendChild(element);
		element.click();
	}
	catch (error) 
	{
		console.log(error);
	}	  
}